import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { ReportCommonService } from "../shared/services/report-common.service";
import { TranslateService } from "@ngx-translate/core";
import {
  PermissionGroupFilterOption,
  UserFilterOption,
} from "../shared/models/filter-options-model";

@Component({
  selector: "share-filter-template",
  templateUrl: "./share.component.html",
  styleUrls: ["./filtersdialog.component.scss"],
})
export class ShareComponent {
  constructor(
    public commonData: ReportCommonService,
    private translateService: TranslateService
  ) {}

  @ViewChild("popupModal") public modal: any;
  private _shareDialogOpened = false;
  @Input()
  set shareDialogOpened(value: boolean) {
    this._shareDialogOpened = value;
    if (value) {
      this.filterShareableUsers();
    }
  }
  get shareDialogOpened(): boolean {
    return this._shareDialogOpened;
  }
  @Input() public sharedUsers: UserFilterOption[] = [];
  @Input() public sharedPermissionGroups: PermissionGroupFilterOption[] = [];
  @Input() public shareableUsersList: UserFilterOption[] = [];
  @Input() public shareablePermissionGroupsList: PermissionGroupFilterOption[] =
    [];
  @Output() public submitted = new EventEmitter();
  @Output() public canceled = new EventEmitter();
  @Output() public shareDialogOpenedChange = new EventEmitter();
  @Output() public sharedUsersChange = new EventEmitter();
  @Output() public sharedPermissionGroupsChange = new EventEmitter();
  public filteredShareableUsersList: UserFilterOption[] = [];

  public usersDropdownSettings = {
    singleSelection: false,
    idField: "staffId",
    textField: "staffFullname",
    itemsShowLimit: 3,
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
    allowSearchFilter: true,
    searchPlaceholderText: this.translateService.instant(
      "_General_Search_Text_"
    ),
  };

  public permissionGroupsDropdownSettings = {
    singleSelection: false,
    idField: "permissionGroupId",
    textField: "permissionGroupName",
    itemsShowLimit: 3,
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
    allowSearchFilter: true,
    searchPlaceholderText: this.translateService.instant(
      "_General_Search_Text_"
    ),
  };

  private filterShareableUsers() {
    this.filteredShareableUsersList = this.shareableUsersList.filter(
      (user) => user.staffId !== this.commonData.currentTemplate.createdUserId
    );
  }

  public clickSave() {
    this.submitted.emit({
      sharedUsers: this.sharedUsers,
      sharedPermissionGroups: this.sharedPermissionGroups,
    });
    this.shareDialogOpened = false;
  }

  public clickCancel() {
    this.canceled.emit();
    this.shareDialogOpened = false;
    var data = this.commonData.mapSharedOptionData();
    this.sharedUsers = data.users;
    this.sharedPermissionGroups = data.groups;
  }

  public close() {
    this.canceled.emit();
    this.shareDialogOpened = false;
    var data = this.commonData.mapSharedOptionData();
    this.sharedUsers = data.users;
    this.sharedPermissionGroups = data.groups;
  }

  public arraysAreEqualById(
    arr1: any[],
    arr2: any[],
    idField: string
  ): boolean {
    if (arr1.length !== arr2.length) return false;
    const ids1 = arr1.map((item) => item[idField]).sort();
    const ids2 = arr2.map((item) => item[idField]).sort();
    return ids1.every((id, idx) => id === ids2[idx]);
  }

  public checkSaveDisabled() {
    const data = this.commonData.mapSharedOptionData();
    const usersEqual = this.arraysAreEqualById(
      data.users,
      this.sharedUsers,
      "staffId"
    );
    const groupsEqual = this.arraysAreEqualById(
      data.groups,
      this.sharedPermissionGroups,
      "permissionGroupId"
    );
    return usersEqual && groupsEqual;
  }
}
